export function toDateFormat(value?: Date | string){
  if(!value) return '';

  const newValue = value instanceof Date ? value.toJSON() : value;
  const date = new Date(newValue);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function toDateTimeFormat(value?: Date | string){
  if(!value) return '';

  const newValue = value instanceof Date ? value.toJSON() : value;
  const date = new Date(newValue);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function toTimeFormat(value?: Date | string){
  if(!value) return '';

  const newValue = value instanceof Date ? value.toJSON() : value;
  const date = new Date(newValue);

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}


